// // export default EmiDueReport;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";

// import "./EmiDueReportTest.css";

// const EmiDueReportTest = () => {
//   const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//   const [emis, setEmis] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [filter, setFilter] = useState("pending"); // default filter

//   const baseUrl = "https://payyug.in/api/loan-emi";

//   const apiUrls = {
//     pending: `${baseUrl}/overdue?superAdminId=${superAdminId}`,
//     today: `${baseUrl}/today?superAdminId=${superAdminId}`,
//     upcoming: `${baseUrl}/upcoming7days?superAdminId=${superAdminId}`,
//   };

//   useEffect(() => {
//     const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//     const fetchEmis = async () => {
//       setLoading(true);
//       try {
//         const res = await axios.get(apiUrls[filter]);
//         setEmis(res.data.emis || []);
//       } catch (err) {
//         setError("Failed to fetch EMI due report");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchEmis();
//   }, [filter]);

//   if (loading)
//     return <div className="EmiDueReport-loading">Loading EMI Report...</div>;
//   if (error) return <div className="EmiDueReport-error">{error}</div>;

//   // Pagination logic
//   const totalPages = Math.ceil(emis.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = emis.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () =>
//     currentPage < totalPages && setCurrentPage(currentPage + 1);

//   // PDF Export
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.setFontSize(18);
//     doc.text("Company EMI Demand Sheet", 14, 20);

//     const tableColumn = [
//       "#",
//       "Customer Name",
//       "Loan Number",
//       "EMI Number",
//       "EMI Amount",
//       "Principal",
//       "Interest",
//       "Outstanding",
//       "Due Date",
//       "status",
//     ];

//     const tableRows = currentData.map((emi, index) => [
//       startIndex + index + 1,
//       emi.customerName,
//       emi.loanNumber,
//       emi.emiNumber,
//       emi.emiAmount,
//       emi.principalComponent,
//       emi.interestComponent,
//       emi.outstanding,
//       new Date(emi.dueDate).toLocaleDateString("en-IN"),
//       emi.status,
//     ]);

//     // ✅ Correct way in v3+ / v5+
//     autoTable(doc, {
//       startY: 30,
//       head: [tableColumn],
//       body: tableRows,
//       theme: "grid",
//       headStyles: { fillColor: [99, 102, 241], textColor: 255 },
//       styles: { fontSize: 10, cellPadding: 3 },
//     });

//     doc.save("EMI_Demand_Sheet.pdf");
//   };

//   return (
//     <div className="emi-due-report-wrapper">
//       <h1 className="emi-due-report-title">📋 EMI Due Report</h1>

//       {/* Filter buttons */}
//       <div className="emi-due-report-filters">
//         {["pending", "today", "upcoming"].map((f) => (
//           <button
//             key={f}
//             className={`emi-due-report-filter-btn ${filter === f ? "active" : ""}`}
//             onClick={() => {
//               setFilter(f);
//               setCurrentPage(1);
//             }}
//           >
//             {f.charAt(0).toUpperCase() + f.slice(1)}
//           </button>
//         ))}
//       </div>

//       {/* Controls: left rows selector, right PDF download */}
//       <div
//         className="emi-due-report-controls"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: "16px",
//         }}
//       >
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//           </select>{" "}
//           entries
//         </label>

//         <button className="emi-due-report-filter-btn" onClick={handleDownloadPDF}>
//           📄 Download PDF
//         </button>
//       </div>

//       <div className="emi-due-report-table-container">
//         <table className="emi-due-report-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Customer Name</th>
//               <th>Loan Number</th>
//               <th>EMI Number</th>
//               <th>EMI Amount</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Outstanding</th>
//               <th>Due Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentData.length === 0 ? (
//               <tr>
//                 <td colSpan="10" className="emi-due-report-empty">
//                   ✅ No records found
//                 </td>
//               </tr>
//             ) : (
//               currentData.map((emi, index) => (
//                 <tr key={emi.id}>
//                   <td>{startIndex + index + 1}</td>
//                   <td>{emi.customerName}</td>
//                   <td>{emi.loanNumber}</td>
//                   <td>{emi.emiNumber}</td>
//                   <td>₹{emi.emiAmount.toLocaleString()}</td>
//                   <td>₹{emi.principalComponent.toLocaleString()}</td>
//                   <td>₹{emi.interestComponent.toLocaleString()}</td>
//                   <td>₹{emi.outstanding.toLocaleString()}</td>
//                   <td>{new Date(emi.dueDate).toLocaleDateString("en-IN")}</td>
//                   <td>
//                     <span
//                       className={`emi-due-report-status ${
//                         emi.status === "pending" ? "pending" : "paid"
//                       }`}
//                     >
//                       {emi.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination controls */}
//       <div className="emi-due-report-pagination">
//         <button
//           className="emi-due-report-pagination-btn"
//           onClick={handlePrev}
//           disabled={currentPage === 1}
//         >
//           ⬅ Prev
//         </button>
//         <span className="emi-due-report-pagination-info">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           className="emi-due-report-pagination-btn"
//           onClick={handleNext}
//           disabled={currentPage === totalPages}
//         >
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default EmiDueReportTest;

// export default EmiDueReport;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import "./EmiDueReportTest.css";
// import { toast } from "react-toastify";

// const API_URL = "https://payyug.in/api";
// const EmiDueReportTest = () => {
//   const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;
//   const [emis, setEmis] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [filter, setFilter] = useState("pending"); // default filter

//   const [centers, setCenters] = useState([]);
//   const [selectedCenter, setSelectedCenter] = useState(null);
//   const [groups, setGroups] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [branchs, setBranchs] = useState([]);
//   const [selectedBranch, setSelectedBranch] = useState(null);
//   const [selectedStatus,setSelectedStatus]= useState("");

//   // Pagination logic
//   // const totalPages = Math.ceil(emis.length / rowsPerPage);
//   const [totalPages,setTotalPages]=useState(1);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   // const currentData = emis.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () =>
//     currentPage < totalPages && setCurrentPage(currentPage + 1);

//    /* ================= FETCH Branch ================= */
//   useEffect(() => {
//     const fetchBranch = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-branch`, {
//           params: {
//             SuperAdminId: localStorage.getItem("adminuserId"),
//             limit: "all",
//           },
//         });
//         // console.log("branch data", res.data);
//         setBranchs(res?.data.branches);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchBranch();
//   }, []);

//   // console.log("slected branch",selectedBranch?.id)
//   /* ================= FETCH CENTERS ================= */
//   useEffect(() => {
//     // if (!selectedBranch?.id) return;
//     const fetchCenters = async () => {
//       try {
//         const superAdminId = localStorage.getItem("adminuserId");
//         if (!superAdminId) return;

//         const res = await axios.get(`${API_URL}/group/centre`, {
//           params: {
//             superAdminId,
//             // branchid: selectedBranch?.id,
//           },
//         });

//         // console.log("center list", res.data?.data);

//         setCenters(res.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchCenters();
//   }, [selectedBranch]);

//   /* ================= FETCH GROUPS ================= */
//   useEffect(() => {
//     if (!selectedBranch?.id) return;
//     if (!selectedCenter?.id) return;

//     const fetchGroups = async () => {
//       try {
//         const superAdminId = localStorage.getItem("adminuserId");

//         const res = await axios.get(`${API_URL}/groupupdate/getall`, {
//           params: {
//             superAdminId,
//             CenterId: selectedCenter?.id,
//           },
//         });
//         setGroups(res.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchGroups();
//   }, [selectedCenter, selectedBranch]);

//   // PDF Export

//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.setFontSize(18);
//     doc.text("Company EMI Demand Sheet", 14, 20);

//     const tableColumn = [
//       "#",
//       "Group Name",
//       "Loan Number",
//       "EMI Number",
//       "EMI Amount",
//       "Principal",
//       "Interest",
//       "Outstanding",
//       "Due Date",
//       "status",
//     ];

//     const tableRows = emis.map((emi, index) => [
//       startIndex + index + 1,
//       emi.loanAccount.groupName,
//       emi.loanAccount.loanAccountNumber,
//       emi.installmentNo,
//       emi.emiAmount,
//       emi.principalComponent,
//       emi.interestComponent,
//       emi.outstanding,
//       new Date(emi.dueDate).toLocaleDateString("en-IN"),
//       emi.status,
//     ]);

//     // ✅ Correct way in v3+ / v5+
//     autoTable(doc, {
//       startY: 30,
//       head: [tableColumn],
//       body: tableRows,
//       theme: "grid",
//       headStyles: { fillColor: [99, 102, 241], textColor: 255 },
//       styles: { fontSize: 10, cellPadding: 3 },
//     });

//     doc.save("EMI_Demand_Sheet.pdf");
//   };

//   const fetchEmis = async (page = 1, limit = rowsPerPage) => {
//     if (!selectedCenter) return;

//     try {
//       setLoading(true);
//       setError(null);

//       const res = await axios.get(
//         `${API_URL}/group-loan/emi/list-filter`,
//         {
//           params: {
//             superAdminId,
//             centerId: selectedCenter?.id,
//             // branchId: selectedBranch.id,
//             groupId: selectedGroup?.id,
//             filterType:selectedStatus==="all"?"":selectedStatus,
//             page,
//             limit,
//           },
//         }
//       );

//       setEmis(res.data?.data || []);
//       setTotalPages(res.data?.totalPages || 1);
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to fetch EMI report.");
//       setError("Failed to fetch EMI report.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!selectedCenter) {
//       toast.error("Please select a Center before filtering.");
//       return;
//     }

//     setCurrentPage(1);
//     await fetchEmis(1, rowsPerPage);
//     toast.success("EMI report filtered successfully!");
//   };

//   useEffect(() => {
//     if (!selectedCenter) return;
//     fetchEmis(currentPage, rowsPerPage);
//   }, [currentPage, rowsPerPage]);

//   return (
//     <div className="emi-due-report-wrapper">
//       <h1 className="emi-due-report-title">📋 EMI Due Report</h1>

//       {/* Filter buttons */}
//       {/* <div className="emi-due-report-filters">
//         {["pending", "today", "upcoming"].map((f) => (
//           <button
//             key={f}
//             className={`emi-due-report-filter-btn ${filter === f ? "active" : ""}`}
//             onClick={() => {
//               setFilter(f);
//               setCurrentPage(1);
//             }}
//           >
//             {f.charAt(0).toUpperCase() + f.slice(1)}
//           </button>
//         ))}
//       </div> */}

//       <section className="pending-disbursal-filter-section">
//         <h2 className="pending-disbursal-title">Pending Disbursal Filter</h2>
//         <p className="pending-disbursal-sub-title">
//           Use filters to refine Emi due report
//         </p>
//         <form className="pending-disbursal-form" onSubmit={handleSubmit}>
//           <div className="pending-disbursal-grid">
//             {/* Branch */}
//             <div className="pending-disbursal-form-group">
//               <label>Select Branch</label>
//               <select
//                 value={selectedBranch?.id || ""}
//                 onChange={(e) => {
//                   const branch = branchs.find(
//                     (br) => br.id === Number(e.target.value)
//                   );
//                   setSelectedBranch(branch);
//                   setSelectedCenter(null); // reset
//                   setSelectedGroup(null); // reset
//                 }}
//               >
//                 <option value="">Select Branch</option>
//                 {branchs.map((b) => (
//                   <option key={b.id} value={b.id}>
//                     {b.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Center */}
//             <div className="pending-disbursal-form-group">
//               <label>Select Center</label>
//               <select
//                 value={selectedCenter?.id || ""}
//                 disabled={!selectedBranch}
//                 onChange={(e) => {
//                   const center = centers.find(
//                     (cn) => cn.id === Number(e.target.value)
//                   );
//                   setSelectedCenter(center);
//                   // setSelectedGroup(null); // reset
//                 }}
//               >
//                 <option value="">Select Center</option>
//                 {centers.map((c) => (
//                   <option key={c.id} value={c.id}>
//                     {c.CenterName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Group */}
//             <div className="pending-disbursal-form-group">
//               <label>Select Group</label>
//               <select
//                 value={selectedGroup?.id || ""}
//                 disabled={!selectedBranch || !selectedCenter}
//                 onChange={(e) => {
//                   const group = groups.find(
//                     (gr) => gr.id === Number(e.target.value)
//                   );
//                   setSelectedGroup(group);
//                 }}
//               >
//                 <option value="">Select Group</option>
//                 {groups.map((g) => (
//                   <option key={g.id} value={g.id}>
//                     {g.groupname}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="pending-disbursal-form-group">
//               <label>Select Status</label>
//               <select
//                 value={selectedStatus || ""}
//                  onChange={(e) => {
//                   setSelectedStatus(e.target.value);
//                 }}
//               >
//                 <option value="">Select Status</option>
//                 <option value="all">All</option>
//                 <option value="today">Today</option>
//                 <option value="tomorrow">Tomorrow</option>
//                 <option value="pending">Pending</option>
//                 <option value="overdue">OverDue</option>

//               </select>
//             </div>

//           </div>
//            <div className="filterbtnpdt">
//                <button type="submit" className="pending-disbursal-submit-btn">
//                     Apply Filter
//                </button>

//            </div>
//         </form>
//       </section>

//       {/* Controls: left rows selector, right PDF download */}
//       <div
//         className="emi-due-report-controls"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: "16px",
//         }}
//       >
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//           </select>{" "}
//           entries
//         </label>

//         <button className="emi-due-report-filter-btn" onClick={handleDownloadPDF}>
//           📄 Download PDF
//         </button>
//       </div>

//       <div className="emi-due-report-table-container">
//         <table className="emi-due-report-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Group Name</th>
//               <th>Loan Number</th>
//               <th>EMI Number</th>
//               <th>EMI Amount</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Outstanding</th>
//               <th>Due Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {emis.length === 0 ? (
//               <tr>
//                 <td colSpan="10" className="emi-due-report-empty">
//                   ✅ No records found
//                 </td>
//               </tr>
//             ) : (
//               emis.map((emi, index) => (
//                 <tr key={emi.id}>
//                   <td>{startIndex + index + 1}</td>
//                   <td>{emi.loanAccount.groupName}</td>
//                   <td>{emi.loanAccount.loanAccountNumber}</td>
//                   <td>{emi.installmentNo}</td>
//                   <td>₹{emi.emiAmount.toLocaleString()}</td>
//                   <td>₹{emi.principalComponent.toLocaleString()}</td>
//                   <td>₹{emi.interestComponent.toLocaleString()}</td>
//                   <td>₹{emi.outstanding.toLocaleString()}</td>
//                   <td>{new Date(emi.dueDate).toLocaleDateString("en-IN")}</td>
//                   <td>
//                     <span
//                       className={`emi-due-report-status ${
//                         emi.status === "pending" ? "pending" : "paid"
//                       }`}
//                     >
//                       {emi.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination controls */}
//       <div className="emi-due-report-pagination">
//         <button
//           className="emi-due-report-pagination-btn"
//           onClick={handlePrev}
//           disabled={currentPage === 1}
//         >
//           ⬅ Prev
//         </button>
//         <span className="emi-due-report-pagination-info">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           className="emi-due-report-pagination-btn"
//           onClick={handleNext}
//           disabled={currentPage === totalPages}
//         >
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default EmiDueReportTest;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx-js-style";
import autoTable from "jspdf-autotable";
import "./EmiDueReportTest.css";
import { toast } from "react-toastify";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  Download,
  FileTextIcon,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";

const API_URL = "https://payyug.in/api";

const EmiDueReportTest = () => {
    const { list:employeeReport } = useSelector((state) => state.employeeReport);
    const dispatch=useDispatch()

  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;
  const navigate = useNavigate();
  const [emis, setEmis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [company, setCompany] = useState(null);

  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [totalPages, setTotalPages] = useState(1);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const [loanType, setLoanType] = useState("");


    useEffect(() => {
      dispatch(fetchEmployeeReport({ page: currentPage, superAdminId,branch:selectedBranch?.id }));
    }, [dispatch, currentPage,selectedBranch?.id, superAdminId]);

      const employeesList = employeeReport?.data || employeeReport || [];

  const handlePrev = () => currentPage > 1 && setCurrentPage((p) => p - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage((p) => p + 1);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`,
        );
        const data = await response.json();

        if (response.ok && data) {
          // Dynamically construct logo URL
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        } else {
          console.error("Failed to fetch company data");
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      } finally {
        setLoading(false);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  /* ================= FETCH Branch ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "all",
          },
        });
        setBranchs(res?.data?.branches || []);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load branches");
      }
    };

    fetchBranch();
  }, []);

  /* ================= FETCH CENTERS ================= */
  useEffect(() => {
    if (!selectedBranch?.id) {
      setCenters([]);
      setSelectedCenter(null);
      return;
    }

    const fetchCenters = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        if (!superAdminId) return;

        const res = await axios.get(`${API_URL}/group/centre`, {
          params: {
            superAdminId,
            branchid: selectedBranch.id,
            limit: 100000,
          },
        });

        setCenters(res.data?.data || []);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load centers");
      }
    };

    fetchCenters();
  }, [selectedBranch]);

  /* ================= FETCH GROUPS ================= */
  useEffect(() => {
    if (!selectedBranch?.id || !selectedCenter) {
      setGroups([]);
      setSelectedGroup(null);
      return;
    }

    const fetchGroups = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");

        const res = await axios.get(`${API_URL}/groupupdate/getall`, {
          params: {
            superAdminId,
            CenterId:
              selectedCenter.id === "all" ? "" : selectedCenter.id || "",
            limit: 100000,
          },
        });

        setGroups(res.data?.data || []);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load groups");
      }
    };

    fetchGroups();
  }, [selectedCenter, selectedBranch]);

  /* ================= FETCH EMIS ================= */
  const fetchEmis = async (page = 1, limit = rowsPerPage) => {
    if (!selectedCenter) return;

    try {
      setLoading(true);
      setError(null);

      const res = await axios.get(`${API_URL}/group-loan/emi/list-filter`, {
        params: {
          superAdminId,
          centerId: selectedCenter.id === "all" ? "" : selectedCenter.id || "",
          groupId: selectedGroup?.id === "all" ? "" : selectedGroup?.id || "",
          filterType: selectedStatus === "all" ? "" : selectedStatus,
          loanType: loanType,
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
          createdBy:selectedEmployee?.id,
          page,
          limit:limit==="All"?100000:limit,
        },
      });

      setEmis(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch EMI report.");
      setError("Failed to fetch EMI report.");
    } finally {
      setLoading(false);
    }
  };

  /* ================= SUBMIT FILTER ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCenter) {
      toast.error("Please select a Center before filtering.");
      return;
    }

    setCurrentPage(1);
    await fetchEmis(1, rowsPerPage);
    toast.success("EMI report filtered successfully!");
  };

  /* ================= PAGINATION FETCH ================= */
  useEffect(() => {
    if (!selectedCenter) return;
    fetchEmis(currentPage, rowsPerPage);
  }, [currentPage, rowsPerPage,selectedEmployee]);


  const calculateOverdueAmount = (currentRow) => {
  if (!currentRow?.loanAccount?.loanAccountNumber) return 0;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return emis.reduce((sum, r) => {
    if (
      r.loanAccount?.loanAccountNumber !==
      currentRow.loanAccount?.loanAccountNumber
    ) {
      return sum;
    }

    if (!r.dueDate) return sum;

    const dueDate = new Date(r.dueDate);
    dueDate.setHours(0, 0, 0, 0);

    const isUnpaid = !["paid", "success", "settled"].includes(
      r.status?.toLowerCase()
    );

    if (dueDate < today && isUnpaid) {
      return sum + Number(r.emiAmount || 0);
    }

    return sum;
  }, 0);
};

  const handleDownloadPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // ================= LOGO =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 25;
    const logoPadding = 2;

    // Border color & thickness
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    // Calculate center of logo
    const centerX = logoX + logoSize / 2;
    const centerY = logoY + logoSize / 2;

    // Radius = half of logo + padding
    const radius = logoSize / 2 + logoPadding;

    // Draw circle
    doc.circle(centerX, centerY, radius);

    // Logo image
    if (company?.logoUrl) {
      try {
        const logoResp = await fetch(company.logoUrl);
        const logoBlob = await logoResp.blob();
        const reader = new FileReader();
        await new Promise((resolve) => {
          reader.onload = () => {
            doc.addImage(
              reader.result,
              "PNG",
              logoX,
              logoY,
              logoSize,
              logoSize,
            );
            resolve();
          };
          reader.readAsDataURL(logoBlob);
        });
      } catch {
        // silent fail
      }
    }

    // ================= COMPANY NAME (AUTO WRAP) =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);

    const nameX = logoX + logoSize + 5;
    const nameY = 18;
    const nameMaxWidth = pageWidth - nameX - 15;

    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth,
    );

    doc.text(companyNameText, nameX, nameY);

    // Calculate Y after company name
    let currentY = nameY + companyNameText.length * 6;

    // ================= COMPANY DETAILS =================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    const detailX = nameX;
    const detailMaxWidth = nameMaxWidth;

    // Address
    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      detailMaxWidth,
    );
    doc.text(addressText, detailX, currentY);
    currentY += addressText.length * 5;

    // Email
    const emailText = doc.splitTextToSize(
      `Email: ${company?.email || "-"}`,
      detailMaxWidth,
    );
    doc.text(emailText, detailX, currentY);
    currentY += emailText.length * 5;

    // Phone
    const phoneText = doc.splitTextToSize(
      `Phone: ${company?.contact || "-"}`,
      detailMaxWidth,
    );
    doc.text(phoneText, detailX, currentY);
    currentY += phoneText.length * 5;

    // Divider
    doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

    // ================= REPORT TITLE =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("Group Emi Due Report", pageWidth / 2, currentY + 14, {
      align: "center",
    });

    const tableColumn = [
      "SN",
      "Account No",
      "Loan Type",
      "Loan Amount",
      "Center",
      "Group",
      "Member",
      "Mobile",
      "Emi Amount",
      "Due Date",
      "Status",
    ];

    const tableRows = emis.map((emi, index) => [
      index + 1,
      emi.loanAccount?.loanAccountNumber || "N/A",
      emi.loanAccount?.loanType || "N/A",
      emi.loanAccount?.loanAmount ? emi.loanAccount?.loanAmount : 0,
      emi.loanAccount?.centerName || "N/A",
      emi.loanAccount?.groupName || "N/A",
      emi.loanAccount?.memberName || "N/A",
      emi.member?.mobileNumber || "N/A",
      emi.emiAmount ? emi.emiAmount : 0,
      emi.dueDate ? new Date(emi.dueDate).toLocaleDateString("en-GB") : "N/A",
      emi.status || "N/A",
    ]);

    autoTable(doc, {
      startY: currentY + 20,
      head: [tableColumn],
      body: tableRows,

      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 3,
        halign: "center",
      },
      headStyles: {
        fontStyle: "bold",
        fontSize: 7,
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },

      didDrawPage: function () {
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;

        doc.setDrawColor(0);
        doc.setLineWidth(0.2);

        // Page border on EVERY page
        doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
      },
    });

    // ================= FOOTER =================
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
      doc.text("Generated by Collection System", 14, pageHeight - 10);
    }

    doc.save("Group_Emi_Due_Report.pdf");
  };

  const exportExcel = () => {
    const data = emis.map((item) => ({
      "State": item.member?.state || "N/A",
      "Region": selectedBranch?.name || "N/A",
      "Branch": selectedBranch?.name || "N/A",
      "Loan Officer Name": item.loanAccount?.officerName || "N/A",
      "Account No": item.loanAccount?.loanAccountNumber || "N/A",
      "Loan Type": item.loanAccount?.loanType || "N/A",
      "Loan Amount": item.loanAccount?.loanAmount
        ? item.loanAccount?.loanAmount
        : 0,
      "Center Name": item.loanAccount?.centerName || "N/A",
      "Group Name": item.loanAccount?.groupName || "N/A",
      "Member Name": item.loanAccount?.memberName || "N/A",
      "Guardian Name": item.member?.guardianName || "N/A",
      "Mobile No.": item.member?.mobileNumber || "N/A",
      "Emi Amount": item.emiAmount ? item.emiAmount : 0,
      "Total Due Amount": calculateOverdueAmount(item),
      "Outstanding amount": item.outstanding ? item.outstanding : 0,
      "Due Date": item.dueDate
        ? new Date(item.dueDate).toLocaleDateString("en-GB")
        : "N/A",
      "Disbursal Date": item?.loanAccount?.disbursalDate
        ? new Date(item?.loanAccount?.disbursalDate).toLocaleDateString("en-GB")
        : "N/A",
    Status: item.status || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);

    // 🔹 Header styling
    const headerCells = Object.keys(data[0]);
    headerCells.forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
      worksheet[cellRef].s = {
        font: {
          bold: true,
          color: { rgb: "FFFFFF" },
        },
        fill: {
          fgColor: { rgb: "1F4E78" },
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    });

    // 🔹 Auto column width
    worksheet["!cols"] = headerCells.map((key) => ({
      wch: Math.max(key.length + 5, 18),
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Report");

    XLSX.writeFile(workbook, "Group_EmiDue_Report.xlsx");
  };

  return (
    <div className="emi-due-report-wrapper">
      {/* Back wrapper */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        <ArrowLeftIcon
          onClick={() => navigate(-1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />

        <h2
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            color: "#333",
          }}
        >
          Group Loan Emi Due Report
        </h2>

        <ArrowRightIcon
          onClick={() => navigate(1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />
      </div>

      <section className="pending-disbursal-filter-section">
        {/* <h2 className="pending-disbursal-title">Emi Due Report Filter</h2>
        <p className="pending-disbursal-sub-title">
          Use filters to refine EMI due report
        </p> */}

        <form className="pending-disbursal-form" onSubmit={handleSubmit}>
          <div className="pending-disbursal-grid">
            {/* Branch */}
            <div className="pending-disbursal-form-group">
              <label>Select Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value),
                  );
                  setSelectedBranch(branch || null);
                  setSelectedCenter(null);
                  setSelectedGroup(null);
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Employee */}
            <div className="pending-disbursal-form-group">
              <label>Select Employee</label>
              <select
                value={selectedEmployee?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const val = e.target.value;
                    const employee = employeesList.find((em) => em.id === Number(val));
                    setSelectedEmployee(employee || null);
                }}
              >
                <option value="">Select Employee</option>
                {employeesList.map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.fullName}
                  </option>
                ))}
              </select>
            </div>
            {/* Center */}
            <div className="pending-disbursal-form-group">
              <label>Select Center</label>
              <select
                value={selectedCenter?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "all") {
                    setSelectedCenter({ id: "all", CenterName: "All" });
                  } else {
                    const center = centers.find((cn) => cn.id === Number(val));
                    setSelectedCenter(center || null);
                  }
                  setSelectedGroup(null);
                }}
              >
                <option value="">Select Center</option>
                <option value="all">All Centers</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            {/* Group */}
            <div className="pending-disbursal-form-group">
              <label>Select Group</label>
              <select
                value={selectedGroup?.id || ""}
                disabled={!selectedBranch || !selectedCenter}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "all") {
                    setSelectedGroup({ id: "all", groupname: "All" });
                  } else {
                    const group = groups.find((gr) => gr.id === Number(val));
                    setSelectedGroup(group || null);
                  }
                }}
              >
                <option value="">Select Group</option>
                <option value="all">All Groups</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}
                  </option>
                ))}
              </select>
            </div>

            {/* Status */}
            <div className="pending-disbursal-form-group">
              <label>Select Status</label>
              <select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">Select Status</option>
                <option value="all">All</option>
                <option value="today">Today</option>
                <option value="tomorrow">Tomorrow</option>
                <option value="pending">Pending</option>
                <option value="overdue">OverDue</option>
              </select>
            </div>
            <div className="pending-disbursal-form-group">
              <label>Loan Type</label>
              <select
                value={loanType}
                onChange={(e) => {
                  const val = e.target.value;
                  setLoanType(val);
                }}
              >
                <option value="">Select Loan Type</option>
                <option value="FIXED">Fixed</option>
                <option value="INDIVIDUAL">Individual</option>
              </select>
            </div>
            <div className="pending-disbursal-form-group">
              <label>From Date</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div className="pending-disbursal-form-group">
              <label>To Date</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>

          <div className="filterbtnpdt">
            <button type="submit" className="pending-disbursal-submit-btn">
              Apply Filter
            </button>
          </div>
        </form>
      </section>

      {/* Controls */}
      <div
        className="emi-due-report-controls"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              const value=e.target.value;
              setRowsPerPage(value==="All"?"All":Number(value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={"All"}>All</option>
          </select>{" "}
          entries
        </label>

        {emis.length > 0 && (
          <div
            className=""
            style={{ display: "flex", gap: "5px", marginTop: "10px" }}
          >
            <button
              className="collection-report-filter-btn"
              style={{ display: "flex", alignItems: "center", gap: "5px" }}
              onClick={exportExcel}
            >
              <FileTextIcon size={18} /> Excel
            </button>
            <button
              className="collection-report-filter-btn"
              style={{ display: "flex", alignItems: "center", gap: "5px" }}
              onClick={handleDownloadPDF}
            >
              <Download size={18} /> PDF
            </button>
          </div>
        )}
      </div>

      {/* Table */}
      <div className="emi-due-report-table-container">
        <table className="emi-due-report-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Loan Account No</th>
              <th>Loan Type</th>
              <th>Loan Amount</th>
              <th>Center Name</th>
              <th>Group Name</th>
              <th>Member Name</th>
              <th>Mobile No</th>
              <th>EMI Amount</th>
              <th>Outstanding</th>
              <th>Due Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {emis.length === 0 ? (
              <tr>
                <td colSpan="10" className="emi-due-report-empty">
                  ✅ No records found
                </td>
              </tr>
            ) : (
              emis.map((emi, index) => (
                <tr key={emi.id || index}>
                  <td>{rowsPerPage==="All"?index+1:(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{emi.loanAccount?.loanAccountNumber || "N/A"}</td>
                  <td>{emi.loanAccount?.loanType || "N/A"}</td>
                  <td>{emi.loanAccount?.loanAmount}</td>
                  <td>{emi.loanAccount?.centerName || "N/A"}</td>
                  <td>{emi.loanAccount?.groupName || "N/A"}</td>
                  <td>{emi.loanAccount?.memberName || "N/A"}</td>
                  <td>{emi.member?.mobileNumber || "N/A"}</td>
                  <td>₹{`${emi.emiAmount ? emi.emiAmount : 0}`}</td>
                  <td>₹{`${emi.outstanding ? emi.outstanding : 0}`}</td>
                  <td>{new Date(emi.dueDate).toLocaleDateString("en-GB")}</td>
                  <td>
                    <span
                      className={`emi-due-report-status ${
                        emi.status === "pending" ? "pending" : "paid"
                      }`}
                    >
                      {emi.status || "-"}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="emi-due-report-pagination">
        <button
          className="emi-due-report-pagination-btn"
          onClick={handlePrev}
          disabled={currentPage === 1}
        >
          ⬅ Prev
        </button>
        <span className="emi-due-report-pagination-info">
          Page {currentPage} of {totalPages}
        </span>
        <button
          className="emi-due-report-pagination-btn"
          onClick={handleNext}
          disabled={currentPage === totalPages}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default EmiDueReportTest;
